import { Box, Typography } from "@mui/material";
import { Component } from "react";
import moment from "moment";
import datalink from "./datalink";
import schema from "./schema";
import { HStack, VStack } from "Components";
import { Authority, ColorX } from "static";
import Formizo from "Components/LabIZO/Formizo";
import { Spacer } from "Components/LabIZO/Stackizo";
import Datumizo from "Components/LabIZO/Datumizo";
import { DatumizoBase, DatumizoOperationType } from "Components/LabIZO/Datumizo/DatumizoProps.interface";
import { AuditLogDetail } from "./AuditLogDetail/AuditLogDetail";

interface AuditLogStates {
  title: string;
  period: { DateRange: [string, string] };
  serverSidePagination: boolean;
  base: DatumizoBase;
}

interface AuditLogProps {}

class AuditLog extends Component<AuditLogProps, AuditLogStates> {
  private MountDatumizo: Record<string, (...args: any[]) => any> = {};

  constructor(props: AuditLogProps) {
    super(props);
    this.state = {
      title: "AUDIT LOG",
      period: { DateRange: [moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), moment().endOf("month").format("YYYY-MM-DD HH:mm:ss")] },
      serverSidePagination: true,
      base: {
        title: "AuditLog",
        exportDoc: "AuditLog",
        schema,
        reqAuth: "AuditLog",

        tablizo: {
          showSelector: true,
          columnsToolbar: false,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
        },

        Connect: {
          List: datalink.List,
          schema: schema.Table,
        },

        operations: {
          [DatumizoOperationType.Export]: {
            url: datalink.Export,
            schema: schema.Export,
          },

          [DatumizoOperationType.Info]: {
            title: "AUDIT LOG DETAILS",
            success: "Audit Log Success",
            fail: "Audit Log Failed: ",
            schema: schema.Info,
            readOnly: true,
            Custom: (id, doc, _onQuit, _onQuitRefresh, _renderFormizo) => {
              return <AuditLogDetail id={id} doc={doc} />;
            },
          },
        },

        buttons: {
          inline: [{ icon: "info", func: "Info", reqFunc: "Info", caption: "Details" }],
          inlineOpposite: [],
          left: [],
          right: [{ icon: "export", func: "Export", caption: (n: number) => `Export (${n === 0 ? "All" : n})`, reqFunc: "Export" }],
        },
      },
    };
  }

  componentDidMount() {
    Authority.Require("AuditLog");
  }

  onMountDatumizo = (callbacks: Record<string, (...args: any[]) => any>) => {
    this.MountDatumizo = callbacks;
  };

  renderDatePicker = () => {
    const { period } = this.state;
    return (
      <Formizo
        width={350}
        height="100%"
        schema={[
          {
            label: "",
            name: "DateRange",
            format: "daterange",
            dateType: "datetime",
            dateFormat: "YYYY-MM-DD HH:mm:ss",
            noLabelGrid: true,
            defaultValue: period.DateRange,
          },
        ]}
        buttons={[]}
        onChange={(value, _n, _v, fetchData) => {
          this.setState((state) => {
            const from = moment(value.DateRange[0]).format("YYYYMMDD");
            const to = moment(value.DateRange[1]).format("YYYYMMDD");
            return {
              period: value,
              base: {
                ...state.base,
                exportDoc: `AuditLog_${from}_${to}`,
              },
            };
          });
          if (fetchData) {
            this.MountDatumizo.Reload();
          }
        }}
      />
    );
  };

  renderTable = () => {
    let { base, serverSidePagination, period } = this.state;
    return (
      <Datumizo
        base={base}
        addOns={{
          ...period,
        }}
        serverSidePagination={serverSidePagination}
        onMounted={this.onMountDatumizo}
        languageSelector={false}
      />
    );
  };

  render = () => {
    const { title } = this.state;
    return (
      <VStack height="100%" width="100%">
        <Box padding={1} width="100%">
          <HStack
            justifyContent="space-between"
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <Typography
              style={{
                alignItems: "left",
                display: "flex",
                fontSize: 25,
                color: ColorX.GetColorCSS("Primary"),
              }}
            >
              {title}
            </Typography>
            {this.renderDatePicker()}
            <Spacer />
          </HStack>
        </Box>

        {this.renderTable()}
      </VStack>
    );
  };
}

export default AuditLog;
